import React, { useState } from 'react';
import InputTextField from './InputTextField';
import VolontarLogo from '../../assets/svg/volontar_logo_white.svg';
import Store from 'eas-react-store';
import AngleRight from './AngleRight';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { applyOrganisationLanguage } from '../../i18n';

function Login(props) {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [organisation, setOrganisation] = useState({});
    const [canEnterPassword, setCanEnterPassword] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [messageError, setMessageError] = useState('');

    const signIn = async (event) => {
        event.preventDefault();

        if (! canEnterPassword) {
            getOrganisation();

            return;
        }

        let result = await props.store.User.loginWithEmailPassword(email, password);

        if (! result.success) {
            setError(false);

            return;
        }

        window.location.reload();
    }

    const getOrganisation = async () => {

        let result = await props.store.Organisation.getOrganisation(email);

        if (result.message == null) {
            setOrganisation(result.organisation);
            setCanEnterPassword(true);

            // First point at which the app learns anything about who is signing in. Does nothing
            // against an older API that does not send the field yet.
            applyOrganisationLanguage(result.language);
        } else {
            setError();
        }
    }

    const setError = (isEmail = true) => {
        setHasError(true);
        setMessageError(isEmail ? t('login.wrongEmail') : t('login.wrongPassword'));
    }

    return (
        <div className="login-page">
            <div className="header"></div>
            <header>
                <img
                    src={VolontarLogo}
                    alt="Logo in white of Volontär App"
                />
            </header>
            <div className="container">
                <div className="organisation">
                    <p className={`organisation-logo ${organisation.icon != null ? '' : 'hide'}`}>
                        <img
                            src={organisation.icon}
                            alt="Logo of the En Appstudio organisation"
                        />
                    </p>

                    <h1 className="organisation-title">
                        <Trans
                            i18nKey="login.signInTo"
                            values={{ organisation: organisation.name != null ? organisation.name : t('login.appName') }}
                            components={[organisation.name != null ? <b /> : <span />]}
                        />
                    </h1>

                    <form className="form-login" method="POST">
                        <InputTextField
                            className={`${! canEnterPassword ? 'field-is-alone' : 'field-is-first'} ${hasError ? 'field-has-error' : ''}`}
                            svgClass={`${! canEnterPassword ? "arrow-right" : ''} ${hasError ? 'has-error' : ''}`}
                            showIcon={! canEnterPassword}
                            name="email"
                            placeholder={t('login.emailAddress')}
                            value={email}
                            onChange={(event) => {
                                if (hasError) {
                                    setHasError(false);
                                }

                                if (canEnterPassword) {
                                    setCanEnterPassword(false);
                                }

                                setPassword('');
                                setEmail(event.target.value)
                            }}
                            onClick={getOrganisation}
                            hasError={hasError}
                            messageError={messageError}
                        />

                        <InputTextField
                            className={`field-is-last ${canEnterPassword ? 'field-transition' : ''} ${hasError ? 'field-has-error' : ''}`}
                            name="password"
                            placeholder={t('login.password')}
                            value={password}
                            onChange={(event) => {
                                if (hasError) {
                                    setHasError(false);
                                }

                                setPassword(event.target.value)
                            }}
                            isPassword={true}
                            hasError={hasError && password !== ''}
                            messageError={messageError}
                        />

                        <button className={`button-login ${canEnterPassword ? 'button-show' : ''}`} onClick={signIn}>
                            {t('login.signIn')}
                        </button>

                        <p className={`forgot-password ${canEnterPassword ? 'show' : ''}`}>
                            <Link to={{
                                    pathname: '/forgot-password',
                                    state: {
                                        email
                                    }
                                }}
                            >
                                <span>{t('login.forgotPassword')}</span>

                                <AngleRight className="forgot-password-icon" />
                            </Link>
                        </p>
                    </form>
                </div>

                <div className="policy">
                    <div className="transition">
                        <div></div>
                        <span>{t('login.or')}</span>
                        <div></div>
                    </div>

                    <a className="button-pingst" href={process.env.REACT_APP_API_LINK}>
                        {t('login.ssoSignIn')}
                        <AngleRight className="button-pingst-icon" />
                    </a>

                    v1.0
                </div>
            </div>
        </div>
    );
}

export default Store.connectStore(Login);
